import { Editor } from '@morningtrain/react-fields'
import { Quill } from 'react-quill'

const Link = Quill.import('formats/link')

class CleanLink extends Link {
  static create (value) {
    const node = super.create(value)
    value = this.sanitize(value)

    node.setAttribute('href', value)
    node.removeAttribute('rel')

    return node
  }
}

Quill.register(CleanLink)

export default Editor
